<template>
  <div class="px-4 w-full lg:w-1/3">
    <div class="border border-grey-light">
      <div class="w-full flex text-sm p-4 bg-grey-lighter border-t-4 border-propqual-orange">
        <strong class="h-6">Your Order Summary</strong>
      </div>
      <div v-if="stage !== 2" class="pt-4 px-4 leading-normal">
        <table v-if="registrants.length > 0" class="w-full">
          <tbody v-for="(registrant, i) in registrants" :key="i" class="border-b border-grey-light">
            <tr><td colspan="2" class="align-top text-sm font-bold pt-3">{{ registrant.first_name + ' ' + registrant.last_name }}</td></tr>
            <tr>
              <td class="align-top text-xs pb-3 pr-3">{{ registrant.course_name }} </td>
              <td class="align-bottom text-right pb-3 text-sm">{{ '£' + parseFloat(registrant.course_fee).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
        <table v-else class="w-full">
          <tbody class="border-b border-grey-light">
            <tr><td colspan="2" class="align-top text-sm pt-3">-</td></tr>
            <tr>
              <td class="align-top text-xs pb-3 pr-3">-</td>
              <td class="align-bottom text-right pb-3 text-sm">£0.00</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="px-4 pt-6">
        <h4 class="block text-sm pb-3">Total</h4>
        <table class="w-full mb-4">
          <tbody>
            <tr>
              <td class="align-top text-sm pb-2">
                Subtotal
              </td>
              <td class="align-top text-right text-sm pb-2">{{ '£' + subtotal }}</td>
            </tr>
            <tr>
              <td class="align-top text-sm pb-3">
                VAT (20%)
              </td>
              <td class="align-top text-right text-sm pb-3">{{ '£' + vat }}</td>
            </tr>
            <tr>
              <td class="align-top text-sm font-bold">
                Total
              </td>
              <td class="align-top text-right text-sm font-bold">{{ '£' + total }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="stage === 2" class="w-full mb-6">
        <hr class="border-b border-grey-light">
        <div class="px-4">
          <p class="mt-4 mb-6 text-xs leading-normal">Before you place your order please check the email for each registered user and the course you have selected them for is correct. An email with their log-in details for the PropQual platform will be sent directly to them.</p>
          <button v-if="registrants.length > 0" class="w-full py-4 text-white text-xs uppercase bg-propqual-orange hover:bg-propqual-orange-dark" @click="$emit('submit')">Make Payment</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Table from '../../components/Table.vue'
export default {
  components: { Table },
  data () {
    return {
      loaded: true
    }
  },
  props: ['stage', 'registrants', 'subtotal', 'vat', 'total']
}
</script>
